export default __webpack_public_path__ + "static/blog-thumb-4-25e046e41a685b44fee59c01478999d6.webp";